import type { JSX, PropsWithChildren } from 'react';
import { Content as PopoverContent, Portal as PopoverPortal } from '@radix-ui/react-popover';
import { styled } from 'styled-components';
import { COLOR_PICKER_POPOVER_MAX_WIDTH_PX } from './consts';

const StyledPopoverContent = styled(PopoverContent)`
  background-color: var(--wui-color-bg-surface);
  border-radius: var(--wui-border-radius-02);
  border: 1px solid var(--wui-color-border);
  box-shadow: var(--wui-elevation-02);
  outline: none;
  display: flex;
  flex-direction: column;
  max-width: ${COLOR_PICKER_POPOVER_MAX_WIDTH_PX}px;
  overflow: hidden;
  z-index: var(--wui-zindex-select);
`;

export type ColorPickerPopoverContentProps = PropsWithChildren;

/**
 * The popover panel that opens when the `ColorPickerTrigger` is activated.
 * Use `ColorPickerSection` to organize content within it.
 */
export const ColorPickerPopoverContent = ({
  children,
}: ColorPickerPopoverContentProps): JSX.Element => {
  return (
    <PopoverPortal>
      <StyledPopoverContent
        align="start"
        sideOffset={4}
      >
        {children}
      </StyledPopoverContent>
    </PopoverPortal>
  );
};

ColorPickerPopoverContent.displayName = 'ColorPickerPopoverContent';
